module.exports = __webpack_public_path__ + "static/media/Path 14.7774b222.png";